export default __webpack_public_path__ + "static/media/loading.1593ee41.svg";